export { default as VideoThumbnail } from './VideoThumbnail';
